import type { RefObject } from 'react';
import { fadeTo } from 'util/animation/fade/fade';
import gsap from 'gsap';
import type { WorkFilterVisualItemRef } from './work-filter-visual-item/WorkFilterVisualItem.data';

interface WorkFilterVisualsRefs {
  elementRef: RefObject<HTMLElement | null>;
}

export function setupTransitionInTimeline(
  timeline: gsap.core.Timeline,
  { elementRef }: WorkFilterVisualsRefs,
): void {
  timeline.fromTo(elementRef.current, {}, {});
}

export function setupTransitionOutTimeline(
  timeline: gsap.core.Timeline,
  { elementRef }: WorkFilterVisualsRefs,
): void {
  timeline.add(fadeTo(elementRef.current as HTMLElement));
}

export function expand(
  containerRef: RefObject<HTMLDivElement | null>,
  isOpen: boolean,
  itemRef?: WorkFilterVisualItemRef,
  immediate: boolean = false,
): void {
  if (containerRef?.current) {
    gsap.to(containerRef.current, {
      height: isOpen
        ? Math.max(
            (itemRef?.elementRef?.current as HTMLElement).offsetHeight,
            (itemRef?.animationRef?.current as HTMLElement).offsetHeight,
          )
        : 0,
      duration: immediate ? 0 : 0.6,
      ease: 'Quad.easeInOut',
      // clearProps: isOpen ? 'height' : '',
      onComplete: () => {
        // ScrollTrigger.refresh();
      },
    });
  }
}
